/**
 * Bandeau « vous n'avez pas de siège » d'un `proprietaire` ou d'un `administrateur` (mode
 * `registre`, lot O3). Ces rôles gèrent l'organisation SANS siège (membres, sièges, licence,
 * transfert : routes exemptées côté serveur) : l'écran de gestion n'est donc jamais remplacé par
 * `SeatRequiredPage`, il porte seulement ce bandeau — « demander un siège » (ou s'en attribuer un
 * depuis la section Sièges) — quand l'auto-siège n'a pas abouti (organisation pleine, siège
 * suspendu…). Le contenu (projets, équipes) reste fermé tant qu'ils n'en ont pas.
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api.js';
import { messageModeleOrganisation } from '../lib/org-errors.js';
import { BTN_GHOST } from '../ui/theme.js';

/**
 * @param {{ organization: { id: string, name: string }, degrade?: boolean }} props
 */
export function SeatRequestBanner({ organization, degrade = false }) {
  const { t } = useTranslation();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const request = async () => {
    setSending(true);
    setError(null);
    try {
      await api.post(`/organizations/${organization.id}/demandes-siege`);
      setSent(true);
    } catch (failure) {
      setError(
        messageModeleOrganisation(failure, t) ??
          t('seatRequired.requestFailed', { message: failure.message }),
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      role="status"
      className="mb-4 flex flex-col gap-2 border-2 border-accent-trait bg-accent-wash px-3 py-2 text-sm text-accent-ink"
    >
      <p>{t('seatRequired.bannerManager', { name: organization.name })}</p>
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          className={BTN_GHOST}
          disabled={sending || sent || degrade}
          onClick={request}
        >
          {t('seatRequired.request')}
        </button>
        {sent && <span>{t('seatRequired.sent')}</span>}
      </div>
      {error && <p role="alert">{error}</p>}
    </div>
  );
}
